import InitiateFollows from './InitiateFollows';

export default InitiateFollows;
